/* eslint-disable import/prefer-default-export */
export const isIOSDevice =
  ['ipad simulator', 'iphone simulator', 'ipod simulator', 'ipad', 'iphone', 'ipod'].includes(
    navigator.platform.toLowerCase(),
  ) ||
  (navigator.userAgent.toLowerCase().includes('mac') && 'ontouchend' in document);
